import { useState, useEffect } from 'react';

const debounce = (fn: () => void, delay: number) => {
  let timerId: NodeJS.Timeout;

  return () => {
    clearTimeout(timerId);
    timerId = setTimeout(fn, delay);
  };
};

export const useScreenWidth = () => {
  const [screenWidth, setScreenWidth] = useState<number>(1080);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    const debouncedUpdateSize = debounce(handleResize, 200);

    window.addEventListener('resize', debouncedUpdateSize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    return () => {
      window.removeEventListener('resize', debouncedUpdateSize);
    };
  }, []);

  return screenWidth;
};
